import { CssBaseline } from "@mui/material";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/home.page";
import { ToastContainer } from "react-toastify";
import { esES, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { PrivateRoute } from "components/PrivateRoute";
import { ErrorPage } from "pages/Error";

import { UserPage } from "pages/user/UserPage";
import { Layout } from "components/Layout/MainLayout";
import { PublicLayout } from "components/Layout/PublicLayout";
import UserNewPage from "pages/user/UserNewPage";


import UserEditPage from "pages/user/UserEditPage";
import {
  ForgotPasswordPage,
  LoginPage,
  NewPasswordPage,
  ResetPasswordPage,
} from "pages/auth";
import "react-toastify/dist/ReactToastify.css";
import {CompanyPage} from "pages/company/CompanyPage";
import { CompanyNewPage } from "pages/company/CompanyNewPage";
import { UserRoles } from "Enums/UserRoles";
import ChangePasswordPage from "pages/change-password/ChangePasswordPage";
import { CompanyEditPage } from "pages/company/CompanyEditPage";
import { PointOfSalePage } from "pages/pointOfSale/PointOfSalePage";
import { PointOfSaleEditPage } from "pages/pointOfSale/PointOfSaleEditPage";
import { PointOfSaleNewPage } from "pages/pointOfSale/PointOfSaleNewPage";
import { OperationPage } from "pages/operations/OperationsPage";
import OperationEditPage from "pages/operations/OperationsEditPage";
import { useAppSelector } from "redux/store";
import ApiKeyPage from "pages/ApiKey.page";
import PeopleOfInterestDowloadCSV from "pages/PeopleOfInterestDowloadCSV.page";

function App() {

  const allowedRoles = [UserRoles.ADMIN, UserRoles.SUPERADMIN,UserRoles.MANAGER];
  const { user } = useAppSelector((state) => state.userLoggedState);
  return (
    <>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        localeText={
          esES.components.MuiLocalizationProvider.defaultProps.localeText
        }
        adapterLocale="en-gb"
      >
        <CssBaseline />
        <ToastContainer autoClose={2500} />

        <Router>
          <Routes>
            <Route path="/login" element={<PublicLayout><LoginPage /></PublicLayout>} />
            <Route path="/forgot-password" element={<PublicLayout><ForgotPasswordPage /></PublicLayout>} />
            <Route
              path="/reset-password/:resetToken"
              element={<PublicLayout><ResetPasswordPage /></PublicLayout>}
            />
            <Route
              path="/verify-email/:verificationCode"
              element={<PublicLayout><NewPasswordPage /></PublicLayout>}
            />
            <Route
              path="/"
              element={
                <PrivateRoute allowedRoles={allowedRoles}>
                  <Layout>
                    {user?.role===UserRoles.SUPERADMIN ? <CompanyPage /> : <OperationPage />}
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/companies"
              element={
                <PrivateRoute allowedRoles={[UserRoles.SUPERADMIN]}>
                  <Layout>
                    <CompanyPage />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/create-company"
              element={
                <PrivateRoute allowedRoles={[UserRoles.SUPERADMIN]}>
                  <Layout>
                    <CompanyNewPage />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/companies/:companyId"
              element={
                <PrivateRoute allowedRoles={[UserRoles.SUPERADMIN]}>
                  <Layout>
                    <CompanyEditPage/>
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/api-key"
              element={
                <PrivateRoute allowedRoles={[UserRoles.ADMIN]}>
                  <Layout>
                  <ApiKeyPage/>
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/people-of-interest"
              element={
                <PrivateRoute allowedRoles={[UserRoles.SUPERADMIN]}>
                  <Layout>
                  <PeopleOfInterestDowloadCSV/>
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/point-of-sale"
              element={
                <PrivateRoute allowedRoles={allowedRoles}>
                  <Layout>
                    <PointOfSalePage />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/create-point-of-sale"
              element={
                <PrivateRoute allowedRoles={allowedRoles}>
                  <Layout>
                    <PointOfSaleNewPage />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/point-of-sale/:pointOfSaleId"
              element={
                <PrivateRoute allowedRoles={allowedRoles}>
                  <Layout>
                    <PointOfSaleEditPage />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/users"
              element={
                <PrivateRoute allowedRoles={allowedRoles}>
                  <Layout>
                    <UserPage />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/crear-usuario"
              element={
                <PrivateRoute allowedRoles={allowedRoles}>
                  <Layout>
                    <UserNewPage />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/users/:userId"
              element={
                <PrivateRoute allowedRoles={allowedRoles}>
                  <Layout>
                    <UserEditPage />
                  </Layout>
                </PrivateRoute>
              }
            />
           
            
           
            
            <Route
              path="/cambiar-contrasenia"
              element={
                <PrivateRoute allowedRoles={allowedRoles}>
                  <Layout>
                    <ChangePasswordPage />
                  </Layout>
                </PrivateRoute>
              }
            />

            <Route
              path="/operations"
              element={
                <PrivateRoute allowedRoles={allowedRoles}>
                  <Layout>
                    <OperationPage />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/operations/:operationId"
              element={
                <PrivateRoute allowedRoles={allowedRoles}>
                  <Layout>
                    <OperationEditPage/>
                  </Layout>
                </PrivateRoute>
              }
            />

            <Route
              path="/unauthorized"
              element={
                  <Layout>
                    <h1>Unauthorized</h1>
                    <ErrorPage />
                  </Layout>
                
              }
            />

            
            

            

            <Route path="/error" element={<ErrorPage />} />
          </Routes>
        </Router>
      </LocalizationProvider>
    </>
  );
}

export default App;
